import http from './index'

export default {
  /*
   * 获取应用菜单
   * */
  menuList (params) {
    return http.get('/front/menu/getHomeMenu', params)
  },
  /*
   * 添加快捷菜单
   * */
  add (params) {
    return http.post('/front/menu/userMenu/save', params)
  },
  /*
   * 获取快捷菜单接口
   * */
  delete (params) {
    return http.post('/front/menu/userMenu/deletion', params)
  },
  // 记录菜单访问次数
  countMenuVisit (params) {
    return http.post(`/front/menu/countMenuVisit/${params}`)
  },
  // 设置导航模式 list/card
  changeNavStyle (params) {
    return http.post('/front/navigate/switch/homeStyle', params)
  },
  getNavStyle (params) {
    return http.get('/front/navigate/homeStyle', params)
  }
}
